/* global $, YT */

class ModalPlayer {
  constructor(mainApp) {
    this.mainApp        = mainApp;
    this.$container     = $('.ModalPlayer')

    var tag             = document.createElement('script');
    tag.src             = "https://www.youtube.com/iframe_api";
    var firstScriptTag  = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      this.player = new YT.Player('YouTubePlayer', {
        width: '640',
        height: '360',
        videoId: '9xptJc7t9v4',
        playerVars: {
          rel: 0,
        }
      });
    }

    $(document).on('click', '.js-play-video' , () => {
      this.play();
    });
    $(document).on('click', '.js-pause-video' , () => {
      this.pause();
    });
  }

  play() {
    this.$container.stop(false).css({'opacity': 0, 'pointer-events': 'auto'})
      .animate({'opacity': 1}, 400, 'easeOutSine', () => {
        this.player.seekTo(0);
        this.player.playVideo();
      });
  }
  pause() {
    this.player.pauseVideo();
    this.$container.stop(false).animate({'opacity': 0}, 400, 'easeInOutSine', () => {
      this.$container.css('pointer-events', 'none');
    });
  }


}
export default ModalPlayer;
